function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff9811",
  d: "M.001 44.522H0v422.955h.001V256.001z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h511.999v341.325H0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.337h511.999V153.6H0zm0 136.537h511.999v68.263H0zm0 136.525h511.999v68.263H0z",
  fill: "#0052b4"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256.001 256.005l-256 170.663V85.332z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M83.478 211.479l11.05 34.01h35.763L101.36 266.51l11.049 34.011-28.931-21.02-28.931 21.02 11.051-34.011-28.931-21.021h35.761z"
});

const SvgCuba = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 511.999 511.999",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCuba, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cuba.05b6baa2.svg";
export { ForwardRef as ReactComponent };